const api_version = "/api/v1";

const ENDPOINTS = Object.freeze({
  LOGIN_URL: `${api_version}/auth/admin/login`,
  SIGNUP_URL: `${api_version}/company/user/signup`,
  VERIFY_ADMIN: `${api_version}/auth/admin/verify`,
  RESEND_OTP: `${api_version}/auth/admin/resend-otp`,
  UPDATE_BY_SUPER_ADMIN: `${api_version}/company/update/byadmin`,
  UPDATE_PASSWORD: `${api_version}/auth/admin/update/password`,
  EVENTS: `${api_version}/event`,
});

export default ENDPOINTS;
